import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import * as _ from 'lodash';
import arrHelper from '@/utils/array-helper';

Vue.use(VueAxios, axios);

const mutations = {
  MUTATION_CLEAR_COUNT_CLIENT: function (state) {
    state.countClientEvent = [];
  },
  MUTATION_SET_COUNT_CLIENT: function (state, counter) {
    state.countClientEvent.push(counter);
  },
  MUTATION_SET_COUNT_TOTAL: function (state, countItem) {
    state.countTotalEvent.push({
      status: countItem.status.toLowerCase(),
      count: parseInt(countItem.countTotal),
      unread: parseInt(countItem.unread) || 0
    });
  },
  MUTATION_SET_EVENT_LIST: function (state, events) {
    let eventsWithIndex = [];
    if (events === null) {
      events = [];
    }
    events.forEach((item, index) => {
      item.index = index;
      eventsWithIndex.push(item);
    });
    state.listEvent = eventsWithIndex;
    state.showRelatedEvents = false;
  },
  MUTATION_SET_EXPAND_ID: function (state, expandId) {
    state.expandId = state.expandId === expandId ? -1 : expandId;
  },
  setUserId: (state, id) => {
    state.userId = id;
  },
  MUTATION_UPDATE_EVENT: (state, eventRespond) => {
    if (eventRespond !== null && (eventRespond.status === 'APPROVED')) {
      let arrEvent = state.listEvent.filter(x => x.id !== eventRespond.id);
      state.listEvent = arrEvent;
      return;
    }
    let currentIndex = eventRespond.index === undefined || eventRespond.index === null ? state.indexOfItemModifying : eventRespond.index;
    if (currentIndex < 0 || currentIndex >= state.listEvent.length || eventRespond === null) {
      return;
    }
    state.listEvent[currentIndex].isLive = eventRespond.isLive;
    state.listEvent[currentIndex].eventName = eventRespond.eventName;
    state.listEvent[currentIndex].durationBackup = eventRespond.duration;
    state.listEvent[currentIndex].shippingAddressBackup = eventRespond.shippingAddress;
    state.listEvent[currentIndex].eventNameBackup = eventRespond.eventName;
    state.listEvent[currentIndex].startTime = eventRespond.startTime;
    state.listEvent[currentIndex].contact = eventRespond.contact;
  },
  MUTATION_UPDATE_EVENT_ID: (state, id) => {
    if (!state.indexOfItemModifying || (state.indexOfItemModifying < 0 || state.indexOfItemModifying >= state.listEvent.length || id === null || id === undefined)) {
      return;
    }
    state.listEvent[state.indexOfItemModifying].id = id;
    state.currentEventId = id;
  },
  MUTATION_SET_LIST_EVENT_STATUS: (state, eventStatus) => {
    if (eventStatus === null || eventStatus === '' || eventStatus === undefined) {
      state.listEventStatus = [];
      return;
    }
    let index = state.listEventStatus.indexOf(eventStatus.toUpperCase());
    if (index === -1) {
      state.listEventStatus.push(eventStatus.toUpperCase());
    } else {
      state.listEventStatus.splice(index, 1);
    }
  },
  MUTATION_SET_ITEM_RELATED: (state, eventItem) => {
    if (eventItem === null || eventItem === undefined) {
      return;
    }
    let newEvent = Object.assign({}, eventItem.item);
    newEvent.relatedInfo = eventItem.relatedInfo;
    state.listBackup = state.listEvent;
    state.listEvent = [newEvent];
    state.listEventRelated = [];
    state.showRelatedEvents = true;
  },
  MUTATION_SET_LIST_BACK: (state) => {
    state.showRelatedEvents = false;
    state.listEventRelated = [];
    state.listEvent = state.listBackup;
  },
  MUTATION_SET_EVENTS_RELATED: (state, arrEvent) => {
    if (arrEvent === null || arrEvent === undefined) {
      return;
    }
    state.listEventRelated = arrEvent;
  },
  MUTATION_DELETE_EVENT_AT_LOCAL: (state, id) => {
    if (state.listEvent.length === 1) {
      state.listEvent.pop();
      return;
    }
    for (let i = 0; i < state.listEvent.length; i++) {
      if (state.listEvent[i].id === id) {
        state.listEvent.splice(i, 1);
        return;
      }
    }
  },
  MUTATION_DELETE_EVENT_AT_LOCAL_MANAGE_TAB: (state, id) => {
    state.listApprovedEvent.forEach(element => {
      element.events.forEach((event, index) => {
        if (event.id === id) {
          element.events.splice(index, 1);
          state.totalApprovedEvents = state.totalApprovedEvents - 1;
        }
      });
    });
  },
  MUTATION_DELETE_EVENTS: (state, ids) => {
    state.listEvent = state.listEvent.filter(e => !ids.includes(e.id));
  },
  MUTATION_CREATE_NEW_EVENT: (state, newEvent) => {
    if (newEvent === null || newEvent === undefined) {
      return;
    }
    let arrEvent = state.listEvent;
    state.listEvent = [newEvent].concat(arrEvent);
    state.listEvent.forEach((element, index) => {
      element.index = index;
      element.showCollapse = index === 0;
    });
    state.flagCreateEvent = false;
  },
  MUTATION_RESTORE_LIST_EVENT: (state) => {
    state.listEventStatus = [];
    state.listEvent = state.listBackup;
  },
  MUTATION_SET_SHOW_RELATED_EVENT: (state, showRelated) => {
    state.listEventStatus = [];
    state.showRelatedEvents = showRelated;
  },
  MUTATION_RESET_EXPAND_ID: (state) => {
    state.expandId = -1;
  },
  MUTATION_SAVE_COLUMN_WIDTH: (state, resizeObj) => {
    if (resizeObj.isTableUser) {
      state.columnTableUserWidth[resizeObj.colName].size = parseFloat(resizeObj.newSize);
    } else {
      state.columnWidth[resizeObj.colName].size = parseFloat(resizeObj.newSize);
    }
  },
  MUTATION_SAVE_COLUMN_STAFFING_WIDTH: (state, resizeObj) => {
    state.columnTableStaffingWidth[resizeObj.colName].size = parseFloat(resizeObj.newSize);
  },
  MUTATION_SAVE_COLUMN_WIDTH_TABLE_EMAIL_HISTORIES: (state, resizeObj) => {
    state.colTableEmailHistories[resizeObj.colName].size = parseFloat(resizeObj.newWidth);
  },
  MUTATION_SET_LIST_ON_SITE_CONTACT: (state, listContact) => {
    state.listOnSiteContact = listContact;
    // state.columnWidth[resizeObj.colNameRight].size = parseFloat(resizeObj.newWidthRight);
  },
  MUTATION_CREATE_EVENT_FLAG: (state, isCreate) => {
    state.flagCreateEvent = isCreate;
  },
  MUTATION_RESET_COLUMN_SIZE: (state, colName) => {
    if (state.columnWidth[colName]) {
      state.columnWidth[colName].size = 0;
    }
    if (state.columnTableUserWidth[colName]) {
      state.columnTableUserWidth[colName].size = 0;
    }
  },
  MUTATION_RESET_COLUMN_SIZE_STAFFING: (state, colName) => {
    if (state.columnTableStaffingWidth[colName]) {
      state.columnTableStaffingWidth[colName].size = 0;
    }
  },
  MUTATION_SET_MESSAGE_ERROR: (state, message) => {
    state.messageError = message;
  },
  MUTATION_SET_ERROR_CODE: (state, errorCodes) => {
    if (errorCodes === undefined || errorCodes === null) {
      state.errorCodes = null;
      return;
    }
    state.errorCodes = errorCodes;
  },
  MUTATION_SET_EVENT_HISTORY: (state, histories) => {
    if (!histories) {
      state.histories = [];
    } else {
      state.histories = histories;
    }
  },
  MUTATION_SET_EVENT_DETAIL_HISTORY: (state, response) => {
    if (!response.events) {
      state.eventDetailHistory = [];
    } else {
      let histories = [];
      response.events.forEach(historyGroup => {
        const date = new Date(historyGroup.timeModified);
        historyGroup.fieldsChange.forEach(history => {
          histories.push({
            fieldName: history.fieldName,
            newValue: history.newValue,
            oldValue: history.previousValue,
            updatedBy: historyGroup.userName,
            timeModified: (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
          });
        })
      })
      state.eventDetailHistory = histories;
    }
  },
  MUTATION_SET_IS_LOADING_EVENT_HISTORY: (state, isLoading) => {
    state.isLoadingEventDetailHistory = isLoading;
  },
  MUTATION_UPDATE_ADDON: (state, updateObj) => {
    if (!state.listEvent || !state.listEvent.length) return;
    if (state.listEvent[updateObj.obj.index] != null) {
      state.listEvent[updateObj.obj.index].addOns = updateObj.addOns;
      let services = state.listEvent[updateObj.obj.index].additionalServices;
      let rs = [];
      services.forEach((item) => {
        if (item.key === updateObj.obj.key) {
          item.value = updateObj.obj.value;
        }
        rs.push(item);
      });
      state.listEvent[updateObj.obj.index].additionalServices = rs;
    }
  },
  MUTATION_UPDATE_EVENT_IN_LIST: (state, event) => {
    if (event === null) return;
    event.lastModifiedAt *= 1000;
    state.listEvent.forEach(item => {
      if (item.id === event.id) {
        for (const key in event) {
          if (event.hasOwnProperty(key)) {
            item[key] = event[key];
          }
        }
      }
    })
  },
  MUTATION_SET_APPROVED_EVENTS: (state, events) => {
    if (events.changeFilter || events.currentPage === 1) {
      state.listApprovedEvent = [];
    }
    events.approvedEvents.forEach((el) => {
      let eventObj = state.listApprovedEvent.find((event) => event.clientId === el.clientId);
      let index = state.listApprovedEvent.indexOf(eventObj);
      if (index >= 0) {
        state.listApprovedEvent[index].events.push(...el.events);
      } else {
        state.listApprovedEvent.push(el);
      }
    });
    state.listApprovedEventBackup = _.cloneDeep(state.listApprovedEvent);
  },
  MUTATION_SEARCH_APPROVED_EVENT: (state, keyword) => {
    keyword = keyword ? keyword.toLowerCase() : '';
    if (keyword === '') {
      state.listApprovedEvent = _.cloneDeep(state.listApprovedEventBackup);
      state.totalApprovedEvents = 0;
      state.listApprovedEvent.forEach((client) => {
        state.totalApprovedEvents += client.events.length;
      });
      return;
    }
    if (state.listApprovedEventBackup.length > 0) {
      state.listApprovedEvent = _.cloneDeep(state.listApprovedEventBackup);
    }
    let result = [];
    state.listApprovedEvent.forEach((client) => {
      if (searchEvent(client, keyword)) {
        let clientItem = _.cloneDeep(client);
        clientItem.events = [];
        for (let item of client.events) {
          if ((item.eventName !== null && item.eventName.toLowerCase().indexOf(keyword) >= 0) ||
            ((item.contactName !== null && item.contactName !== undefined) ? item.contactName.toLowerCase().indexOf(keyword) >= 0 : false) ||
            (item.prefDate !== null && item.prefDate.toLowerCase().indexOf(keyword) >= 0) ||
            ((item.state !== null && item.state !== undefined) ? item.state.toLowerCase().indexOf(keyword) >= 0 : false)) {
            clientItem.events.push(item);
          }
          if ((client.clientName !== null && client.clientName.toLowerCase().indexOf(keyword) >= 0 && clientItem.events.length === 0) ||
            (client.eventManagerName !== null && client.eventManagerName.toLowerCase().indexOf(keyword) >= 0 && clientItem.events.length === 0)) {
            clientItem.events.push(...client.events);
            break;
          }
        }
        result.push(clientItem);
      }
    });
    state.listApprovedEvent = result;
    state.totalApprovedEvents = 0;
    state.listApprovedEvent.forEach((client) => {
      state.totalApprovedEvents += client.events.length;
    });
  },
  MUTATION_SET_DATE_HAS_DATA: (state, dates) => {
    state.datesHasData = dates;
  },
  MUTATION_SET_LOCKED_DATE: (state, dates) => {
    // date = [{
    //   id,
    //   getLockedDate: 'MM/DD/YYYY'
    // }];
    let arr = [];
    dates.forEach((item, index) => {
      arr.push(item.lockedDate);
    });
    state.lockedDates = arr;
  },
  MUTATION_SET_DATE_RANGE_HAS_DATA: (state, dates) => {
    state.dateRangeHasData = dates;
  },
  MUTATION_SET_IS_LOADING: (state, isLoading) => {
    state.isLoading = isLoading;
  },
  MUTATION_SAVE_STAFF_LIST: (state, list) => {
    state.staffList = list;
  },
  MUTATION_CREATE_NEW_TEMP_STAFF: (state) => {
    state.staffList = [{
      id: 0,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      role: '',
      payRates: 0,
      address: '',
      events: '',
      isEditing: true
    }].concat(state.staffList || []);
    state.expandId = 0;
  },
  MUTATION_SAVE_EVENT_STAFF: (state, list) => {
    state[list.listType] = list.data;
  },
  MUTATION_SAVE_ASSIGN_STAFF_MODAL_KEY: (state, key) => {
    state.openEventStaffModal = key;
  },
  MUTATION_SAVE_MANAGE_EVENT_REPORTS: (state, eventList) => {
    state.manageEventReports = eventList;
  },
  MUTATION_SAVE_SLIDER_VALUE_REPORTS: (state, value) => {
    state.sliderValue = value;
  },
  MUTATION_SET_STAFF_DETAIL: (state, obj) => {
    state.staffDetail = obj;
  },
  MUTATION_SORT_EVENT_BY_FIELD_NAME: (state, sortObj) => {
    state.listEvent.sort(arrHelper.sortFunction(sortObj.fieldName, sortObj.isReverse, sortObj.fieldType));
  },
  MUTATION_SET_CURRENT_EVENT: (state, data) => {
    state.currentEvent = data;
  },
  MUTATION_SET_CURRENT_RELATED_EVENTS: (state, data) => {
    state.currentEvent.relatedEvents = _.cloneDeep(data);
  },
  MUTATION_SET_LIST_EVENT_GROUP: (state, data) => {
    state.listEventGroup = data;
  },
  MUTATION_UPDATE_EVENT_GROUP: (state, {groupId, groupName, data}) => {
    let group = state.listEventGroup.find(e => e.id === groupId);
    if (!data) {
      state.listEventGroup = state.listEventGroup.filter(e => e.id !== groupId);
      state.listSingleEvent = state.listSingleEvent.concat(group.data);
      sortDate(state.listSingleEvent, state.sort.reverse);
      return;
    }

    let eventId = data.eventId;
    let relatedEventIds = data.relatedEventsId;
    if (!group) {
      let groupData = state.listSingleEvent.filter(e => relatedEventIds.includes(e.id));
      sortDate(groupData, state.sort.reverse);

      let newGroup = { id: eventId, name: groupName, data: groupData }
      setMinMaxDate(newGroup);

      state.listEventGroup.push(newGroup);
      state.listSingleEvent = state.listSingleEvent.filter(e => !relatedEventIds.includes(e.id));
    } else {
      let eventsInSingleList = state.listSingleEvent.filter(e => relatedEventIds.includes(e.id));
      let eventsInGroup = group.data.filter(e => relatedEventIds.includes(e.id));
      let eventsShouldNotInGroup = group.data.filter(e => !relatedEventIds.includes(e.id));

      let groupData = eventsInGroup.concat(eventsInSingleList);
      sortDate(groupData, state.sort.reverse);

      let newGroup = { id: eventId, name: groupName, data: groupData }
      setMinMaxDate(newGroup);
      state.listEventGroup.splice(state.listEvent.indexOf(e => e.id === groupId), 1, newGroup);
      state.listSingleEvent = state.listSingleEvent.filter(e => !relatedEventIds.includes(e.id));
      state.listSingleEvent = state.listSingleEvent.concat(eventsShouldNotInGroup);
    }

    sortDate(state.listSingleEvent, state.sort.reverse);

    function sortDate (data, reverse) {
      data.sort((a, b) => reverse ? (new Date(b.prefDate) - new Date(a.prefDate)) : (new Date(a.prefDate) - new Date(b.prefDate)));
    }

    function setMinMaxDate (group) {
      if (!group.data || !group.data.length) return;
      group.minDateEventGroup = group.data[0].prefDate;
      group.maxDateEventGroup = group.data[group.data.length - 1].prefDate;
    }
  },
  MUTATION_UPDATE_EVENT_GROUP_NAME: (state, {id, name, data}) => {
    let group = state.listEventGroup.find(item => item.id === id);
    if (!group) return;
    group.name = name;
  },
  MUTATION_SET_LIST_SINGLE_EVENT: (state, data) => {
    state.listSingleEvent = data;
  },
  MUTATION_SET_SORT_DATA: (state, data) => {
    state.sort.type = data.type;
    state.sort.reverse = data.reverse;
  },
  MUTATION_SET_EVENT_LIST_CREATE: function (state, newEvent) {
    if (newEvent === null || newEvent === undefined) {
      return;
    }
    let arrEvent = state.listEvent;
    state.listEvent = [newEvent].concat(arrEvent);
  },
  MUTATION_SET_IS_DOWNLOADING: function (state, status) {
    state.isDownloading = status;
  }
};

function searchEvent (client, keyword) {
  if ((client.clientName !== null && client.clientName.toLowerCase().indexOf(keyword) >= 0) ||
    ((client.eventManagerName !== null && client.eventManagerName !== undefined) ? client.eventManagerName.toLowerCase().indexOf(keyword) >= 0 : false)) {
    return true;
  }
  for (let item of client.events) {
    if ((item.eventName !== null && item.eventName.toLowerCase().indexOf(keyword) >= 0) ||
      ((item.contactName !== null && item.contactName !== undefined) ? item.contactName.toLowerCase().indexOf(keyword) >= 0 : false) ||
      (item.prefDate !== null && item.prefDate.toLowerCase().indexOf(keyword) >= 0) ||
      ((item.state !== null && item.state !== undefined) ? item.state.toLowerCase().indexOf(keyword) >= 0 : false)) {
      return true
    }
  }
  return false;
}

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/events/mutations.js